<template>
  <section>
    <header :style="isFixed ? '' : { background: backgroundHeader }" class="px-12 w-full z-[9] sm-max:px-4"
      :class="isFixed && !noFixed ? 'fixed bg-[#ffffffe0] shadow-[0_2px_3px_#0003] z-[1000] left-0 top-0 pt-0' : 'pt-4 relative'">

      <div class="flex pt-2">
        <div class="w-full pb-2">
          <div class="flex items-center justify-between text-center inner-center">
            <div class="logo-left lg:px-4">
              <div>
                <nuxt-img :src="logoLifeBoost" :alt="logoLifeBoostAlt" :class="isFixed ? 'w-44' : 'w-64'" width="650"
                  height="215" preload class="sm-max:w-36"></nuxt-img>
              </div>
            </div>
            <div class="menu-right ">
              <button :style="{ background: backgroundButtonColorHead, color: colorButtonHead }"
                :class="devMode && 'split-test-outline'" type="button"
                class="inline-block px-4 py-3 text-xs text-black uppercase rounded-md font-ww-medium menu-scroll sm-max:text-left sm-max:text-xs lg:text-17 lg:py-4 sm-max:w-full bg-buttonHead md:rounded sm-max:block"
                @click="scrollTo(scrollTrigger)" :data-event-label="'nav_bar_btn'" :data-event-action="'button_click'"
                :data-event-name="'experiment_event'">{{ getDiscountText }}</button>
            </div>
          </div>
        </div>
      </div>

    </header>
  </section>
</template>

<style scoped>
/* CSS transitions for the menu */
.navbar-default {
  transition: height 0.5s ease;
}

.text {
  padding: 50px;
}

header {
  transition: all 0.25s ease-in-out;
}

.fixed {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  background-color: rgba(255, 255, 255, .88);
  box-shadow: 0 2px 3px rgba(0, 0, 0, .2);
}
</style>

<script>


export default {
  props: {
    backgroundHeader: {
      type: String,
      default: 'white'
    },
    logoLifeBoost: {
      type: String,
      default: '/black-logo.svg',
    },
    logoLifeBoostAlt: {
      type: String,
      default: 'logo-life-booast',
    },
    getDiscountText: {
      type: String,
      default: 'GET DISCOUNT',
    },
    backgroundButtonColorHead: {
      type: String,
      default: 'rgb(255 190 0 1))',
    },
    colorButtonHead: {
      type: String,
      default: 'white',
    },
    scrollTrigger: {
      type: String,
      default: "the-products"
    }
  },
  setup() {
    const devMode = useCookie('devMode')
    const isFixed = ref(false);
    const noFixed = forceNoFixed();
    const openMenu = ref(false);
    defineBuilderComponent({
    friendlyName: 'Header',
    canHaveChildren: true,
    inputs: [
      { name: 'backgroundHeader', type: 'color', defaultValue: 'white' },
      {
        name: 'logoLifeBoost',
        type: 'file',
        allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg'],
        required: true,
        defaultValue: 'black-logo.svg',
      },
      {
        name: 'logoLifeBoostAlt',
        type: 'string',
        defaultValue: 'logo-life-boost',
      },
      {
        name: 'getDiscountText',
        type: 'string',
        defaultValue: 'GET DISCOUNT',
      },
      {
        name: 'backgroundButtonColorHead',
        type: 'color',
        defaultValue: ''
      },
      {
        name: 'colorButtonHead',
        type: 'color',
        defaultValue: ''
      },      
      {
        name: 'scrollTrigger',
        type: 'string',
        defaultValue: 'the-products'
      },
    ],
  })
    return {
      isFixed,
      openMenu,
      devMode,
      noFixed
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.isFixed = window.scrollY > 0;
    },
    toggleMenu() {
      this.openMenu = !this.openMenu;
    },
    beforeEnter(el) {
      el.style.height = '0';
    },
    enter(el, done) {
      el.style.height = el.scrollHeight + 'px';
      el.addEventListener('transitionend', done);
    },
    beforeLeave(el) {
      el.style.height = el.scrollHeight + 'px';
    },
    leave(el, done) {
      el.style.height = '0';
      el.addEventListener('transitionend', done);
    },
  },
}



</script>